module.exports = __webpack_public_path__ + "img/map-icon.f9dfaf38.svg";